import { useDispatch } from "react-redux";
import { show, hide } from "redux-modal";
import { ButtonClose } from "./style";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { STOCK_STATUS } from "../../../../constants/index";

export const useStock = (refresh) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handlerClosePopup = (popupName) => {
    dispatch(hide(popupName));
  };

  const onSuccess = () => {
    if (refresh) {
      refresh();
    }
    handlerClosePopup("ModalForm");
  };

  const compareBigbagDate = async (data) => {
    dispatch(
      show("ModalForm", {
        body: (
          <>
            <div className="row mb-1">
              <div className="col-12 text-end">
                <ButtonClose
                  type="button"
                  onClick={() => handlerClosePopup("ModalForm")}
                >
                  <i className="fa-solid fa-xmark"></i>
                </ButtonClose>
              </div>
            </div>
            <div className="row justify-content-center mb-3">
              <div className="col-12">
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    const startDate = e.target.startDate.value;
                    const endDate = e.target.endDate.value;

                    handlerClosePopup("ModalForm");
                    // navigate(`/resultados?start=${startDate}&end=${endDate}`);
                  }}
                >
                  <div className="mb-3">
                    <label>{t("forms.stock.labels.dateInit")}</label>
                    <input
                      type="date"
                      name="startDate"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label>{t("forms.stock.labels.dateEnd")}</label>
                    <input
                      type="date"
                      name="endDate"
                      className="form-control"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label>{t("forms.stock.labels.status")}</label>
                    <select name="status" className="form-control" required>
                      <option value=""></option>
                      {STOCK_STATUS.map((item) => (
                        <option key={item.code} value={item.code}>
                          {t(item.label)}
                        </option>
                      ))}
                    </select>
                  </div>
                  <button type="submit" className="btn btn-primary">
                    {t("forms.stock.labels.compare")}
                  </button>
                </form>
              </div>
            </div>
          </>
        ),
      })
    );
  };

  return {
    compareBigbagDate,
  };
};
